import React from 'react';
import EmailTextBlock from './EmailTextBlock';
import EmailImageBlock from './EmailImageBlock';
import EmailButtonBlock from './EmailButtonBlock';

const BLOCK_RENDERERS = { text: EmailTextBlock, image: EmailImageBlock, button: EmailButtonBlock };

/**
 * Columns block — renders 2-3 column layout in the canvas.
 */
export default function EmailColumnsBlock({ props, onChange, isSelected }) {
  const count = props.column_count || 2;
  const ratios = (props.column_ratio || '50-50').split('-').map(Number);
  const columns = props.columns || [];

  const updateColumnBlock = (colIdx, blockIdx, newBlockProps) => {
    const newColumns = JSON.parse(JSON.stringify(columns));
    newColumns[colIdx].blocks[blockIdx].props = newBlockProps;
    onChange({ ...props, columns: newColumns });
  };

  return (
    <div style={{ padding: props.padding || '8px 24px', display: 'flex', gap: props.gap || '16px' }}>
      {Array.from({ length: count }).map((_, colIdx) => {
        const pct = ratios[colIdx] || Math.floor(100 / count);
        const colBlocks = columns[colIdx]?.blocks || [];
        return (
          <div key={colIdx} style={{ width: `${pct}%`, minHeight: '40px' }} className="border border-dashed border-stone-200 rounded-lg">
            {colBlocks.length === 0 ? (
              <div className="flex items-center justify-center h-full text-[10px] text-stone-300 p-4">Column {colIdx + 1}</div>
            ) : (
              colBlocks.map((block, blockIdx) => {
                const Renderer = BLOCK_RENDERERS[block.block_type];
                if (!Renderer) return <div key={blockIdx} className="p-2 text-xs text-stone-400">[{block.block_type}]</div>;
                return <Renderer key={block.block_id || blockIdx} props={block.props} onChange={p => updateColumnBlock(colIdx, blockIdx, p)} isSelected={false} />;
              })
            )}
          </div>
        );
      })}
    </div>
  );
}
